import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// PRD 19 §5.1 (Completed state) + §6.2 (transition flow):
//   Sign-up Success → Auto-Approval Completion Notice → [Click Login] → Login Screen.
// Rendered in-place where the form was, so the page header / language switcher
// / footer stay mounted.
export const SignupCompletionNotice = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const actionButtonRef = useRef<HTMLButtonElement>(null);

  // Focus the primary action so Enter activates "Go to login" immediately
  // and the SR announces the completion title via the surrounding role="status".
  useEffect(() => {
    actionButtonRef.current?.focus();
  }, []);

  return (
    <div
      className="signup-page__completion"
      role="status"
      aria-live="polite"
    >
      <h2 className="signup-page__completion-title">{t('signup.completion.title')}</h2>
      <p className="signup-page__completion-body">{t('signup.completion.body')}</p>
      <button
        ref={actionButtonRef}
        type="button"
        className="btn btn-lg btn-primary signup-page__submit"
        onClick={() => navigate('/login')}
      >
        {t('signup.completion.action')}
      </button>
    </div>
  );
};
